import { cn } from "../../lib/utils";

const Badge = ({ variant = "brouillon", children }) => {
  const variants = {
    brouillon: "bg-slate-100 text-slate-800",
    en_cours: "bg-blue-100 text-blue-800",
    termine: "bg-emerald-100 text-emerald-800",
    genere: "bg-purple-100 text-purple-800",
    envoye: "bg-amber-100 text-amber-800",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium",
        variants[variant]
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
